const translations = {
  "en": {
    "I've paused syncing your accounts": "I've paused syncing your accounts",
    "Resume account sync": "Resume account sync"
  },
  "zh-tw": {
    "I've paused syncing your accounts": "我已暫停同步您的帳戶。",
    "Resume account sync": "恢復帳戶同步"
  }
};

export default translations;
